module.exports = __webpack_public_path__ + "img/c803463.png";